import { OnInit, Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ModalController } from '@ionic/angular';
import { SensorLimitBaseComponent } from './sensor-limit-base.component';
import { DevicesService } from '../../../views/main/intranet/devices/devices.service';
import { LimitType } from '@models/device';
import { LimitService } from '@shared/services/limit.services';

@Component({
  standalone: false,
  selector: 'app-sensor-limit',
  templateUrl: './sensor-limit.component.html',
  styleUrls: ['./sensor-limit.component.scss']
})
export class SensorLimitComponent extends SensorLimitBaseComponent implements OnInit {

  constructor(
    devicesService: DevicesService,
    toastService: ToastService,
    modalCtrl: ModalController,
    limitService: LimitService

  ) {
    super(devicesService, toastService, modalCtrl, limitService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.type = LimitType.LIMIT;
    if (this.isEdit()) {
      this.selectedSensor = this.sensors.find((s) => s.id == this.data.deviceSensorId);
      this.form = new UntypedFormGroup({
        name: new UntypedFormControl(this.data.name, [Validators.required]),
        property: new UntypedFormControl(this.data.property, [Validators.required]),
        value: new UntypedFormControl(this.data.value, [Validators.required]),
        isVisible: new UntypedFormControl(this.data.isVisible),
        colorCode: new UntypedFormControl(this.data.colorCode),
        notificationType: new UntypedFormControl(this.data.notificationType)
      });
    } else {
      this.form = new UntypedFormGroup({
        name: new UntypedFormControl(null, [Validators.required]),
        property: new UntypedFormControl(null, [Validators.required]),
        value: new UntypedFormControl(null, [Validators.required]),
        isVisible: new UntypedFormControl(true),
        colorCode: new UntypedFormControl("#000"),
        notificationType: new UntypedFormControl()
      });
    }

    if (this.selectedSensor) {
      this.position = this.selectedSensor.position;
    }

    if (this.modeEditNoti && !this.selectedSensor && this.getSensors().length == 1) {
      this.selectedSensor = this.getSensors()[0];
      this.position = this.selectedSensor.position;
    }
  }

  selectOption(event): void {
    let selectedAttribute = event.value;
    this.form.value.property = selectedAttribute;
  }

  checkValues(): boolean {
    if (!this.form) {
      console.error('El formulario no está inicializado.');
      return false;
    }
    return this.form.valid;
  }
  
}